import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=0531f1d2&scoped=true&"
import script from "./Legend.vue?vue&type=script&lang=ts&"
export * from "./Legend.vue?vue&type=script&lang=ts&"
import style0 from "./Legend.vue?vue&type=style&index=0&id=0531f1d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0531f1d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDivider,VTab,VTabItem,VTabs,VTabsItems})
